<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">	
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-2">
                        <label>Período</label>
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" 
                        :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR" :disabled="desabilitarAcoes"/>				
                    </div> 
                    <div class="p-field p-col-12 p-md-5">
                        <label>Empresa</label>
                        <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" 
						optionLabel="cnpjNome" optionValue="id" placeholder="Selecione" :disabled="desabilitarAcoes"/>
                    </div>
                    <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Atualizar" icon="pi pi-refresh" @click="listar"  :disabled="desabilitarAcoes"/>
                    </div>                                 
                </div>

				<DataTable :value="solicitacoes" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-between">		
								<div class="p-text-left" style="padding-top: 0px;">									
									<h6 style="font-weight: bold;" class="ik-text-primary" v-if="exibirSpin">
										<i class="pi pi-spin pi-spinner ik-text-primary" 
										style="font-size: 1rem; font-weight: bold;" ></i> 
										Monitorando o processamento das solicitações de Relatórios/Documentos...</h6>
								</div>		
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="nome" header="Item"></Column>
					<Column field="dataSolicitacao" header="Data Solicitação">
						<template #body="slotProps">
							{{ formatarData(slotProps.data.dataSolicitacao) }}
						</template>
					</Column>	
                    <Column field="dataInicioProcessamento" header="Data Início Processamento">
						<template #body="slotProps">
							{{ formatarData(slotProps.data.dataInicioProcessamento) }}
						</template>
					</Column>	
                    <Column field="dataFinalProcessamento" header="Data Final do Processamento">
						<template #body="slotProps">
							{{ formatarData(slotProps.data.dataFinalProcessamento) }}
						</template>
					</Column>	
                    <Column field="status" header="Status">
						<template #body="slotProps">
							{{ capitalize(slotProps.data.status) }}
						</template>
					</Column>                  		
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-download" title="Baixar Arquivo" 
							class="p-button-rounded p-button-primary p-mr-2" 
							v-if="slotProps.data.status == 'PROCESSADO' && !slotProps.data.linkExpirado" 
							@click="baixarArquivo(slotProps.data)"/>
							
							<Button icon="pi pi-download" title=":(" 
							class="p-button-rounded p-button-primary p-mr-2" disabled v-else/>

							<Button icon="pi pi-info-circle" title="Mensagem" 
							class="p-button-rounded p-button-warning" 
							v-if="slotProps.data.mensagem && slotProps.data.status == 'PROCESSADO'" 
							@click="exibirMensagens(slotProps.data)"/>

							<Button icon="pi pi-info-circle" title="Mensagem" 
							class="p-button-rounded p-button-warning" 
							v-if="slotProps.data.status == 'ERRO'" 
							@click="exibirMensagens(slotProps.data)"/>

						</template>
					</Column>
				</DataTable>

				<Dialog :visible.sync="exibirDialogMensagens" header="Mensagem" :modal="true" class="p-fluid" :style="{width: '60vw'}">			
					<DataTable :value="mensagens" :paginator="true" :rows="10"
						paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
						:rowsPerPageOptions="[10]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
						class="p-datatable-sm p-datatable-striped">						
						<Column field="mensagem" header="Mensagem"></Column>						  
					</DataTable>			
					<template #footer>
						<Button label="OK" icon="pi pi-check" @click="exibirDialogMensagens=false"/>
					</template>
				</Dialog>

			</div>
		</div>
	</div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import { exibirMensagem, localeCalendarBR, preViewUrlArquivo, abrirArquivoComDefault } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
	relatorioService: null,
	data() {
		return {	
			exibirDialogMensagens: false,
			pararTimeout: false,	
			desabilitarAcoes: false,
			exibirSpin: false,	
			mapMonitoramento: new Map(),
			solicitacoes: [],	
            cnpjs: [],
            idCnpjSelecionado: null,
            localeCalendarBR: localeCalendarBR,
            mesAno: new Date(),
            rangeData: '',	
			maxTimeout: 0,//ver incrementarTiemout
			filtro: {},
			mensagens: []
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),	
		...mapActions('sessao', ['atualizarCacheEmpresa']), 
        /**
         * 
         */	
		listar() {			
			if(!this.idCnpjSelecionado) {
                return;
            }
			let requisicao = {
				idCnpj: this.idCnpjSelecionado,
				mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),
			}
			this.relatorioService.listarSolicitacoes(requisicao)
            .then(resp => {
				this.processarSolicitacoes(resp.data);               
            })
            .catch(erro => {exibirMensagem(this, erro)});   
		},		
		/**
		 * 
		 */
		buscarSolicitacao(id) {
			if(this.pararTimeout) {
				return;
			}
			this.relatorioService.buscarSolicitacao(id)
            .then(resp => {
				let solicitacao = resp.data;						
				if(solicitacao.status == 'FILA' || solicitacao.status == 'PROCESSANDO') {
					this.solicitacoes = [solicitacao];		
					this.incrementarTimeout();
					if(solicitacao.nome == 'AFD') {
						setTimeout(() => { this.buscarSolicitacao(id); }, 15000);// 15 segundos
					} else {						
						setTimeout(() => { this.buscarSolicitacao(id); }, this.maxTimeout);
					}	
				} else {
					this.reset();
					this.carregarValidarLinkDownload([solicitacao]);
				}
            })
            .catch(erro => {
				this.reset();
				exibirMensagem(this, erro)
			});   
		},
		/**
		 * 
		 */
		listarSolicitacoesPorIds() {
			if(this.pararTimeout) {
				return;
			}
			let ids = [];
			this.solicitacoes.forEach(sol => {
				ids.push(sol.id);
			});
			this.relatorioService.listarPorIds(ids)
            .then(resp => {
				this.processarSolicitacoes(resp.data);       
            })
            .catch(erro => {
				this.reset();
				exibirMensagem(this, erro)
			});   
		},
		/**
		 *
		 */
		processarSolicitacoes(respSolicitacoes) {
			try {
				let solicitacoesPendentes = [];			
				respSolicitacoes.forEach(sol => {
					if(sol.status == 'FILA' || sol.status == 'PROCESSANDO') {						
						solicitacoesPendentes.push(sol);						
					} 
				});
				if(solicitacoesPendentes.length > 0) {
					this.exibirSpin = true;
					this.desabilitarAcoes = true;
					this.solicitacoes = solicitacoesPendentes;
					this.incrementarTimeout();
					setTimeout(() => {						
						this.listarSolicitacoesPorIds();
					}, this.maxTimeout);
				} else {
					this.reset();
					this.carregarValidarLinkDownload(respSolicitacoes);
				}   
			} catch(erro) {
				console.log(erro);
				this.reset();
				this.carregarValidarLinkDownload(respSolicitacoes);
			}
		},
		/**
		 * 
		 */
		incrementarTimeout() {
			if(this.maxTimeout == 0) {
				this.maxTimeout = 3000;
				return;
			}
			if(this.maxTimeout == 3000) {
				this.maxTimeout = 4000;
				return;
			}
			this.maxTimeout = 5000;
		},
		/**
		 * 
		 */
		carregarValidarLinkDownload(respSolicitacoes) {
			this.solicitacoes = [];			
			respSolicitacoes.forEach(sol => {				
				let passado = Date.parse(sol.dataValidadeLink);
				let agora = Date.now();
				sol['linkExpirado'] = (!sol.link || (agora > passado));				
				this.solicitacoes.push(sol);
			})
		},
        /**
         * 
         */       
         listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
			if(cacheEmpresa.idCnpjSelecionado) {				
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }			    
            if(this.$route.query.id) {	
				this.exibirSpin = true;
				this.desabilitarAcoes = true;			
                this.buscarSolicitacao(this.$route.query.id);            
            } else {
				this.listar();
			}			
        },
		/**
		 * 
		 */
		baixarArquivo(documento) {	
			if(!documento.link) {
				return;
			}
			if(documento.nomeArquivo.split('.')[1] == 'pdf') {
				preViewUrlArquivo(documento.link);
			} else {
				abrirArquivoComDefault(documento.link);
			}		
		},		
		/**
		 * 
		 */
		atualizarCache() {
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
            this.atualizarCacheEmpresa(cacheEmpresa); 
        },
		/**
		 * 
		 */
		exibirMensagens(solicitacao) {
			this.mensagens = [];
			let itens = solicitacao.mensagem.split('#');
			itens.forEach(msn => {
				if(msn != 'ERROS') {
					this.mensagens.push({ mensagem: msn });
				}
			});
			this.exibirDialogMensagens = true;
		},
		/**
		 * 
		 */
		capitalize(str) {
			if(!str) {
				return '';
			}
			return str.charAt(0).toUpperCase() + str.slice(1);
		},
		/**
		 * 
		 */
		reset() {
			this.exibirSpin = false;
			this.desabilitarAcoes = false;
			this.mapMonitoramento.clear();
		},
		/**
		 * 
		 */
		formatarData(strData) {
			if(strData) {
				let partes = strData.split(' ');
				let partesData = partes[0].split('-');
				return partesData[2] + '/' + partesData[1] + '/' + partesData[0] + ' ' + partes[1];
			}
			return '';
		},
        /**
         * 
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-5)+':'+anoAtual;     
        },
	},
	created() {
		this.maxTimeout = 0;
		this.relatorioService = new RelatorioService();		
	},
	mounted() {		
        this.criarRangeData();
        this.listarCnpjs();		
	},
	beforeDestroy() {
        this.pararTimeout = true;  
    }
}
</script>

<style scoped>
</style>